// Staff in-call screen (roadmap #41), route /staff/callcomponent. Ported from
// qr-phone-frontend call.component.js (v3.2.0.0): on entry it notifies the server that
// this staff answered (call-answered) and marks the call connected, then hands the media
// setup to the shared signaling core (VideoState isCallStatus="IN").
import { useEffect } from 'react'
import BrandLockup from '../components/BrandLockup'
import { useNavigate } from 'react-router-dom'
import VideoState from '../core/VideoState'
import StaffCallView from './StaffCallView'
import { globals } from '../core/globals'
import { socket } from '../core/socket'
import { getAuthUser } from '../core/auth'
import { httpRequest } from '../core/http'
import { fetchIceConfig, getIceConfig } from '../core/iceConfig'
import { updateCallStatus } from '../core/callStatus'
import { t } from '../i18n'

const StaffCall = () => {
  const navigate = useNavigate()
  const user = getAuthUser()
  const user_email = globals.email

  // TELL THE SERVER THIS STAFF ANSWERED. THE SERVER THEN SENDS staff-details TO THE CALLER,
  // WHICH KICKS OFF THE OFFER/ANSWER EXCHANGE DRIVEN BY THE CORE.
  const handleReceiveNotification = async () => {
    globals.userFromNotification = true
    const callerSocketID = globals.callerSocketID
    const staffs = globals.callStaffData
    if (callerSocketID) {
      try {
        const notificationObject = {
          staffEmail: user_email,
          callerSocketId: callerSocketID,
          calleeSocketId: socket.id,
          call_id: globals.call_id,
          staffs: staffs,
        }
        socket.emit('call-answered', notificationObject)
      } catch (error) {
        console.log('call-answered emit error', error)
      }
    }
  }

  useEffect(() => {
    // ICE CONFIG MUST BE PRESENT BEFORE THE PEER CONNECTION IS CREATED (E.G. WHEN A
    // BACKGROUND NOTIFICATION OPENED THIS ROUTE WITHOUT VISITING THE DASHBOARD FIRST).
    if (!getIceConfig()) fetchIceConfig()

    if (user_email && !globals.userFromNotification) {
      const payload = { action: 'starttime', call_id: globals.call_id }
      httpRequest('static/updatecalltime', 'POST', payload).then()
      updateCallStatus(globals.call_id, 'ANSRD', { isCallConnected: 1 }).then()
      handleReceiveNotification().then()
    }

    return () => {
      globals.hasAnswered = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_email])

  // PREVENT BACK NAVIGATION / PULL-TO-REFRESH WHILE THE CALL IS UP.
  useEffect(() => {
    window.history.pushState(null, '', null)
    window.onpopstate = () => window.history.go(1)
    document.body.style.overscrollBehaviorY = 'contain'
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
      return ''
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.onpopstate = null
      document.body.style.overscrollBehaviorY = ''
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  if (!globals.call_id) {
    return (
      <div className="cf-page">
        <div className="cf-card cf-staff-card">
          <BrandLockup />
          <p className="cf-subtitle">{t.staffNoActiveCall}</p>
          <button className="cf-btn cf-btn-secondary" onClick={() => navigate('/staff/dashboard')}>
            {t.back}
          </button>
        </div>
      </div>
    )
  }

  return (
    <VideoState isCallStatus={'IN'}>
      <StaffCallView />
    </VideoState>
  )
}

export default StaffCall
